import { moduleFactory } from "@/factories/module";
import { googleIdentityTriggerLogIn } from "@/modules/google-identity/logIn";
import { _googleIdentityParseOAuthCode } from "@/modules/google-identity/parseOAuthCode";

export const googleIdentityModule = moduleFactory.create({
  triggerLogIn: googleIdentityTriggerLogIn,
  parseOAuthCode: _googleIdentityParseOAuthCode,
});
